<template>
    <div class="group-rule-wrap" @click="toggleRoleShow">
        <div class="group-rule-head">
            <div class="head-left">
                <span class="bold">拼团</span>
                <span>流程</span>
            </div>
            <div class="head-right">
                <span>规则</span>
                <img src="https://m.tuniucdn.com/fb2/t1/G5/M00/22/01/Cii-tFy1ad-IEah1AAAAlv9u8MQAAVJXgP__u4AAAES972_w640_h0_c0_t0.png" class="icon" />
            </div>
        </div>
        <div class="group-rule-body">
            <div class="step">
                <img src="https://m2.tuniucdn.com/fb2/t1/G5/M00/42/C8/Cii-tFzFXOOIIjC_AAACFzs15l4AAVY2AP__dEAAAIv507.png" />
                <span>团长开团</span>
            </div>
            <img src="https://m2.tuniucdn.com/fb2/t1/G5/M00/49/85/Cii-tFzFXjqIbKJ2AAAAznqyGO4AAVahgP__vYAAAEK453.png" class="icon" />
            <div class="step">
                <img src="https://m1.tuniucdn.com/fb2/t1/G5/M00/31/8B/Cii-tFzFXdKIZuZmAAACnCUGZF8AAVSHQP__UwAAAK0645.png" />
                <span>邀请好友</span>
            </div>
            <img src="https://m2.tuniucdn.com/fb2/t1/G5/M00/49/85/Cii-tFzFXjqIbKJ2AAAAznqyGO4AAVahgP__vYAAAEK453.png" class="icon" />
            <div class="step">
                <img src="https://m3.tuniucdn.com/fb2/t1/G5/M00/42/01/Cii-slzFXduIeBEUAAACuc0r_QEAAVYpQP__S8AAALR780.png" />
                <span>拼团成功</span>
            </div>
            <img src="https://m2.tuniucdn.com/fb2/t1/G5/M00/49/85/Cii-tFzFXjqIbKJ2AAAAznqyGO4AAVahgP__vYAAAEK453.png" class="icon" v-if="prdTmpId != 8"/>
            <div class="step" v-if="prdTmpId != 8">
                <img src="https://m3.tuniucdn.com/fb2/t1/G5/M00/47/16/Cii-slzFXeKIePVXAAACg_hdJSwAAVZwgP__WUAAAKb514.png" />
                <span>商家发货</span>
            </div>
        </div>
        <div v-if="ruleShow" @click.stop>
            <div class="popup">
                <div class="popup-head">拼团规则</div>
                <div class="popup-body">
                    <p>1、用户点击途牛拼购活动，开团成为团长，并邀请好友参团；也可以加入正在进行中的拼购团（用户需下单付款成功后才能成功开团或参团）。</p>
                    <p v-if="prdTmpId == 8">2、在团有效时间内凑齐成团人数，即可拼购成功。</p>
                    <p v-else>2、在团有效时间内凑齐成团人数，即可拼购成功，商家将会发货。</p>
                    <p>3、在团有效时间内未凑齐成团人数，即拼购失败，系统自动取消订单并全额退款，支付金额将会原路退回付款账户。</p>
                    <p>4、团有效时间，即拼购允许邀请好友参团的时间，可在拼购详情页查看倒计时。</p>
                    <p>5、用户参团过程中所参团已拼团成功时，用户成功付款后系统会自动创建一个新团。</p>
                    <p>6、用户可在“我的-我的订单”查看自己的拼购订单。</p>
                    <p>7、在拼团有效期内，已支付订单不允许申请退款。</p>
                    <p>8、商品如有质量问题，可以联系商家补发或者退款。</p>
                </div>
                <div class="popup-foot">
                    <div class="i-know" @click="toggleRoleShow">知道了</div>
                </div>
            </div>
            <div class="mask"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'groupRule',
        props: {
            prdTmpId: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                ruleShow: false
            }
        },
        methods: {
            toggleRoleShow() {
                this.ruleShow = !this.ruleShow
            }
        },
        watch: {
            ruleShow (val) {
                if (val) {
                    this.scrollTop = document.scrollingElement.scrollTop;
                    document.body.style.position="fixed";
                    document.body.style.width="100%";
                    document.body.style.top = -this.scrollTop + 'px';
                } else {
                    document.body.removeAttribute('style');
                    document.scrollingElement.scrollTop = this.scrollTop;
                }
            }
        }
    }
</script>

<style lang="scss">
    .group-rule-wrap {
        margin-top: 9px;
        border-radius: 18px;
        background: #fff;
        padding: 18px;
        .group-rule-head {
            height: 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .head-left {
                font-family: PingFangSC-Light;
                font-size: 18px;
                color: #1A1A1A;
                line-height: 18px;
                .bold {
                    font-family: PingFangHK-Semibold;
                    font-weight: 700;
                    color: #383838;
                }
            }
            .head-right {
                font-family: PingFangSC-Regular;
                font-size: 13px;
                color: #A5A5A5;
                line-height: 13px;
                display: flex;
                align-items: center;
                position: relative;
                left: 12px;
                .icon {
                    height: 24px;
                    width: 24px;
                }
            }
        }
        .group-rule-body {
            height: 16px;
            margin-top: 18px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .step {
                display: flex;
                align-items: center;
                span {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #383838;
                    line-height: 12px;
                    margin-left: 3px;
                }
                img {
                    height: 16px;
                    width: 16px;
                }
            }
            .icon {
                height: 14px;
                width: 14px;
            }
        }
        .popup {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 296px;
            height: 450px;
            background: #FFF;
            border-radius: 18px;
            z-index: 21;
            padding: 21px 18px 18px;
            box-sizing: border-box;
            .popup-head {
                height: 24px;
                font-family: PingFangSC-Medium;
                font-size: 20px;
                color: #383838;
                text-align: center;
                line-height: 20px;
            }
            .popup-body {
                height: 309px;
                margin-top: 15px;
                font-family: PingFangSC-Light;
                font-size: 16px;
                color: #383838;
                line-height: 24px;
                overflow: auto;
                p {
                    margin-bottom: 10px;
                }
            }
            .popup-foot {
                margin-top: 21px;
                .i-know {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 42px;
                    width: 100%;
                    background-image: linear-gradient(-180deg, #30BF4E 0%, #4DDC77 100%);
                    background: #32C45E;
                    border-radius: 21px;
                    font-family: PingFangSC-Medium;
                    font-size: 18px;
                    color: #FFFFFF;
                }
            }
        }
    }
    .mask {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 20;
        background: rgba(0, 0, 0, 0.4);
    }
</style>



// WEBPACK FOOTER //
// groupRule.vue